import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Assessment from "./Assessment";
import defaultAvatar from '../assests/user-profile/default-avatar.png'
import UserProfile from "../UI/UserProfile";
import classes from './IslandData.module.css'
import { ActivityTypeEnum } from "../models/ActivityTypeEnum";
import { useParams } from "react-router-dom";
import { ProgressMapIslandTypes } from "../models/ProgressMapIslandTypes"
import { useMapStyle } from "../hooks/useMapStyle";
// const IslandData = ({ positions, tagId, userTag, endLevel, heightSumMapsCreated, mapRef, mapheight, toggelEye }) => {
const IslandData = ({ handleShowLessonViewer, positions, index, tagId, userPlace, aiCourse, endLevel, lessoneType, heightSumMapsCreated, mapRef, mapheight, lessonsList, studyGroupId, setMessagePopup }) => {

    const user = useSelector(state => state.auth.user);
    const { applictionName } = useParams();
    const { LevelPointImgBlue } = useMapStyle();
    const uiData = useSelector((state) => state.general.uiData);
    const [lessonesListType, setLessonesListType] = useState()

    useEffect(() => {
        if (uiData) {
            setLessonesListType(uiData[applictionName].lessonesListType)
        }
    }, [uiData])

    function focusLevel() {
        const scrollTop = mapheight - (positions.bottom + heightSumMapsCreated) - positions.height - 250;
        const scrollLeft = positions.left + (positions.centerLeft) - (mapRef.current.getBoundingClientRect().width) / 2
        mapRef.current.scrollTo({ left: `${scrollLeft}px`, top: `${scrollTop}`, behavior: "smooth" });
    }

    return (

        <>
            {lessonesListType && <div className={`${classes.LevelOnMapLayer2}  ${userPlace ? classes.SelectedLevel : ''} ${endLevel ? classes.LastLevel : ''} ${lessoneType === lessonesListType[1] ? classes.Contest : ''}`}
                style={{ bottom: `${positions.bottom + heightSumMapsCreated}px`, left: `${positions.left}px`, width: `${positions.width}px`, height: `${positions.height}px` }}
                onClick={focusLevel}>

                <div className={classes.LevelName} style={{ top: `${positions.nameTop}px`, left: `${positions.nameLeft}px`, width: `${positions.nameWidth && `${positions.nameWidth}px`}` }}> {tagId.name} </div>

                {!aiCourse ? <div className={classes.LevelIcon} style={{ top: `${positions.centerTop}px`, left: `${positions.centerLeft}px` }}>
                    <div className={`${endLevel && !lessoneType.includes(ProgressMapIslandTypes.contest) ? classes.EndLevelIcon : lessoneType.includes(ProgressMapIslandTypes.enrichment) ? classes.EnrichmentLevelIcon : ''}`}>{!endLevel && lessoneType == 'lessons' && LevelPointImgBlue}  </div>
                    {userPlace && lessoneType == lessonesListType[0] ? <div className={classes.MyLevelIcon}>
                        <div className={classes.MyLevelImg} >
                            <UserProfile width="57px"
                                image={user.profileImage ?
                                    `${user.profileImage}` :
                                    defaultAvatar}
                            />
                        </div>
                    </div> : null}
                </div>
                    :
                    <div className={classes.LevelIcon} style={{ top: `${positions.centerTop}px`, left: `${positions.centerLeft}px` }}  >
                        <div >
                            {lessoneType === 'lessons' && <img src={uiData.aiCourses?.EndLevelIcons[index % uiData.aiCourses?.EndLevelIcons.length]} alt="icon"></img>}
                        </div>
                    </div>
                }

                <div className={classes.LevelAssignments}>
                    {lessonsList && lessonsList.slice(Math.max(lessonsList.length - 5, 0)).map((a, index) =>
                        <Assessment aiCourse={aiCourse} key={a.id} handleShowLessonViewer={handleShowLessonViewer} dataAssessment={a.assessments?.find(a => ActivityTypeEnum[a.activityType] == ActivityTypeEnum.Final)} dataLesson={a} positions={positions.assignmentsStyle[index]} studyGroupId={studyGroupId} setMessagePopup={setMessagePopup}></Assessment>
                    )}
                </div>
                {lessoneType.includes(ProgressMapIslandTypes.contest) && (uiData[applictionName].contestImg || aiCourse) &&
                    <div className={classes.ContestImg}>
                        <img src={!aiCourse ? uiData[applictionName].contestImg : uiData.aiCourses?.contestImg} className={classes.ContestIslandImg} alt="contest" />
                    </div>
                }
            </div >}
        </>
    )

}

export default IslandData;